import { Controller } from "@hotwired/stimulus"

// Handles adding and removing link rows within a panel.
// Targets:
//   list        – <ol> that rows are appended to
//   rowTemplate – <template> for a blank new row
//   addBtn      – the "+ Add another link" button

const MAX_ROWS = 20

export default class extends Controller {
  static targets = ["list", "rowTemplate", "addBtn"]

  connect() {
    this.#reindex()
    this.#syncAddBtn()
  }

  add(event) {
    if (!this.hasListTarget || !this.hasRowTemplateTarget) return

    const rows = this.#rows()
    if (rows.length >= MAX_ROWS) return

    const prefix = event.currentTarget.dataset.fieldPrefix || ""
    const index  = rows.length + 1
    const clone  = this.rowTemplateTarget.content.cloneNode(true)

    // Assign name attributes: select gets [type], input gets [url]
    const select = clone.querySelector("select")
    const input  = clone.querySelector("input[type='text']")
    if (select) select.name = `${prefix}[${index}][type]`
    if (input)  input.name  = `${prefix}[${index}][url]`

    // Update the row number label
    const label = clone.querySelector("span")
    if (label) label.textContent = `${index}.`

    this.listTarget.appendChild(clone)
    this.#syncAddBtn()
  }

  remove(event) {
    event.currentTarget.closest(".stub-link-row")?.remove()
    this.#reindex()
    this.#syncAddBtn()
  }

  // ── private ──────────────────────────────────────────────────────

  #rows() {
    return this.hasListTarget
      ? Array.from(this.listTarget.querySelectorAll(".stub-link-row"))
      : []
  }

  #reindex() {
    this.#rows().forEach((row, i) => {
      const label = row.querySelector("span")
      if (label) label.textContent = `${i + 1}.`

      const select = row.querySelector("select")
      const input  = row.querySelector("input[type='text']")
      if (select?.name) select.name = select.name.replace(/\[\d+\]/, `[${i + 1}]`)
      if (input?.name)  input.name  = input.name.replace(/\[\d+\]/, `[${i + 1}]`)
    })
  }

  #syncAddBtn() {
    if (!this.hasAddBtnTarget) return
    this.addBtnTarget.classList.toggle("hidden", this.#rows().length >= MAX_ROWS)
  }
}
